import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const environmentConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Object.values(environmentConfig).every(Boolean);
const firebaseConfig = isFirebaseConfigured ? environmentConfig : {
  apiKey: "local-preview",
  authDomain: "local-preview.invalid",
  projectId: "local-preview",
  storageBucket: "local-preview.invalid",
  messagingSenderId: "0",
  appId: "1:0:web:local-preview",
};
export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    cacheSizeBytes: 200 * 1024 * 1024,
    tabManager: persistentMultipleTabManager(),
  }),
});
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, "asia-southeast1");

if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true") {
  try {
    const authPort = Number(import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT || 9699);
    const firestorePort = Number(import.meta.env.VITE_FIREBASE_FIRESTORE_EMULATOR_PORT || 8180);
    connectAuthEmulator(auth, `http://127.0.0.1:${authPort}`, { disableWarnings: true });
    connectFirestoreEmulator(db, "127.0.0.1", firestorePort);
    connectStorageEmulator(storage, "127.0.0.1", 9399);
    connectFunctionsEmulator(functions, "127.0.0.1", 5101);
  } catch {
    // Vite hot reload can reuse already-connected Firebase service instances.
  }
}
